/*eslint-disable */
import React, { Component } from "react";
import { Grid, Header, Icon, Button, Dropdown, Divider, Segment } from "semantic-ui-react";
import OrderDetailsHeader from "./OrderDetailsHeader";
import ReadAxios from "../../axiosComponent/read";
import PdfAxios from "../../axiosComponent/downloadpdf";
import CreateAxios from '../../axiosComponent/create';
import FileCreatAxios from "../../axiosComponent/fileupload"
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import ShipmentOrderTable from "./shipmentOrderTable";
import { translate } from "react-i18next";
import VendorRepliesTable from "./vendorRepliesTable";
import { Form as Formiker, Field as Fieldmik, Formik } from 'formik';
import FormikAllotedVehicles from "./AllotedVehicleDetails"
import cogoToast from "cogo-toast";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { connect } from "react-redux";
import moment from 'moment';
import BLrender from "../../common/bl_no";
import 'moment-timezone';
import DeliveryDetailComponentRebuilt from "./DeliveryDetailComponentRebuilt";

class AllotedOrderDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dispatch_locations: [],
      orderDetail: null,
      routeDetails: null,
      broadcastDetails: null,
      deliveries: null,
      serviceType: null,
      documents: null,
      order: null,
      files: [],
      blList: [],
      bldocuments: [],
      broadcastTimeLeft: null,
      show_current_bl: null,
      // current_order: null,
      updateDoc: "",
      shipmentId: "",
      shipmentDetail: [],
      mystyle: {
        display: "table-cell",
        opacity: "1",
        verticalalign: "middle"
      }
    };
  }

  //   TODO: make both at same time
   componentDidMount() {
    let orderId = this.props.location.search.split("=")[1];
    
    //TODO: null handling for api call
    let vendorId = localStorage.getItem("vendorId");
    // let shipmentId = ""
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${orderId}/vendor/${vendorId}`,
    }).then((res) => {
          if(res?.data?.result){
            this.setState({
              orderDetail: res?.data?.result?.shipment,
              shipmentId: res.data.result.shipment.vendor_shipment_id,
              routeDetails: res.data.result.route_details,
              broadcastDetails: res.data.result.broadcast,
              deliveryDetails: res.data.result.deliveries,
              serviceType: res.data.result.service_type,
              order: res.data.result,
              forceUpdate: false,
            });
          }     
        this.getBlList(orderId)
        let delivery_array = []
        let delivery_details = res.data.result.deliveries
        if (delivery_details) {
          for (const key in delivery_details) {
            if (delivery_details.hasOwnProperty(key)) {
              const element = delivery_details[key];
              delivery_array.push(element)

            }
          }
        }
        this.setState({
          deliveries: delivery_array
        })
      })
      .catch((err) => {
        console.log(err);
      });

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.state.shipmentId}`,
    })
      .then((res) => {
        this.setState({
          shipmentDetail: res.data.shipment,
        });
        if (this.state.shipmentDetail) {
          for (const key in this.state.shipmentDetail) {
            if (this.state.shipmentDetail.hasOwnProperty(key)) {
              const element = this.state.shipmentDetail[key];
              this.setState({
                documents: element
              })
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });

    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/dispatchLocation?customer_no=1123&user_id=82`,
    }).then((res) => {
      this.setState({ dispatch_locations: res.data.resultSet })
    })
      .catch((err) => {
        console.log(err);
      });
  }

  getOrderDetails = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.state.shipmentId}`,
    })
      .then((res) => {
        this.setState({
          shipmentDetail: res.data.shipment,
        });
        if (this.state.shipmentDetail) {
          for (const key in this.state.shipmentDetail) {
            if (this.state.shipmentDetail.hasOwnProperty(key)) {
              const element = this.state.shipmentDetail[key];
              this.setState({
                documents: element
              })
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getDocType = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type
        var shipDocId = docType.filename
        if (type == docT) {
          return type == docT
        }
      }
    }
  }

  getDocs = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      var arr = []
      var count = []
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type
        var shipDocName = docType.filename
        var shipDocId = docType.shipment_doc_id
        if (type == docT) {
          count.push({ "id": shipDocId, "name": shipDocName })
        }
      }
      arr.push({ "data": count })
      return count
    }
  }

  getBlList = (order) => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order}/bl/list`,
    }).then((res) => {
      let tempArray = [];
      let info = res.data.data;
      tempArray = info.split(',');
      let bLOptions = tempArray.map((item, index) => {
        return {
          key: index,
          value: item,
          text: item,
          raw: { item },
        };
      });
      this.setState({
        blList: bLOptions,
        current_bl: bLOptions[0].key,
      })
      this.setState({
        show_current_bl: this.state?.blList[this.state.current_bl]?.value
      })
      ReadAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents`,
      }).then((res) => {
        this.setState({
          bldocuments: res.data.data
        })
      })
        .catch((err) => {
          console.log(err);
        });
    })
      .catch((err) => {
        console.log(err);
      });
  }

  returnDispatchLoc = (id) => {
    let temp = ""
    this.state.dispatch_locations.map((item) => {
      if (item.id == id) {
        temp = item.dispatch_location_name
      }
    })
    return temp
  }

  handleDispatchLocation = (dispatchLocationID) => {
    if (dispatchLocationID && this.state.dispatch_locations.length > 0) {
      return this.returnDispatchLoc(dispatchLocationID)
    } else if (this.state.dispatch_locations.length == 0) {
      return '-';
    }
  }

  setCurrentBLToShow = (name, data) => {
    this.setState({
      current_bl: data.options.find((ele) => ele.value === data.value).key,
      show_current_bl: data.value
    });
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${data.value}/documents`,
    }).then((res) => {
      this.setState({
        bldocuments: res.data.data
      })
    })
      .catch((err) => {
        console.log(err);
      });
  };

  getfileName = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type
        var shipFileNeame = docType.filename
        if (type == docT) {
          return shipFileNeame
        }
        // return shipDocId
      }
    }
  }
  getDocId = (type) => {
    if (this.state.bldocuments && this.state.bldocuments.length > 0) {
      for (const docType of this.state.bldocuments) {
        var docT = docType.doc_type
        var shipDocId = docType.shipment_doc_id
        if (type == docT) {
          return shipDocId
        }
        // return shipDocId
      }
    }
  }

  downloadFile = (id) => {

    PdfAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents/${id}/download`,
    })
      .then((res) => {
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setCurrentOrderToShow = (name, data) => {
    this.setState({
      current_order: data.options.find((ele) => ele.value === data.value).key,
    });
  };

  uploadFile = (id) => {
    document.getElementById(id).click();
  }

  updateFile = (name, id, value) => {
    let values = { [name]: value }
    FileCreatAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/shipments/${id}/update-file`,
      payload: { ...values },
    })
      .then((res) => {
        this.props.success({
          type: "success",
          messageHeader: "Success",
          messageBody: "File Updated Successfully",
        });
        // window.location.reload();
      })
      .catch((err) => {
        this.props.error({
          type: "error",
          messageHeader: "Error",
          messageBody: err.response.data.error,
        });
        window.location.reload();
      });
  }

  //   TODO: null handling
  render() {
    const { orderDetail, show_current_bl, deliveries, blList, serviceType } = this.state;
    const orderTruckLoadType = serviceType && serviceType.service_type_id == 2 ? 2 : 1
    const { t } = this.props;
    // const documents = this.state.orderDetail;
    const shipmentDetail = this.state.bldocuments;
    const shipmentOrderDetail = this.state.shipmentDetail?.orders
    const routeDetails = this.state.routeDetails;
    const broadcastDetails = this.state.broadcastDetails;
    const deliveryDetails = this.state.deliveryDetails;
    const order = this.state.order;
    let timezone = localStorage.getItem("timezone");
    const fispq_and_fe_docs = this.getDocs("fispq_and_fe")
    const coa_docs = this.getDocs("coa_certificate_of_analysis")
    var hideRejectValue = order ? (order.allotment_status.allotment_code == "REJECT" ? true : false) : ""


    const handleAllocationForPTL = () => {
      let Id = window.location.search.split("=")[1];
      CreateAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${Id}/allocate/vehicle`,
        payload: {
          vendor_id: Number(localStorage.getItem("vendorId"))
        }
      }).then((response) => {
        cogoToast.success("Successfully Allocated")
        setTimeout(() => { window.location.reload(); }, 1000)
      })
        .catch((err) => {
          cogoToast.error(err?.response?.data?.message)
        });
    }

    return (
      <React.Fragment>
        <OrderDetailsHeader
          title={t("alloted_title") || "Allocated Order Details"}
          LinkName="/alloted-orders"
          hideInterest={true}
          hideUpdateDetails={true}
          order_status="alloted"
          hideReject={hideRejectValue}
        // movement = {order.vendor_interest_status}
        />
        {orderDetail ? (

          <>

            <div className="pad w3-white small">
              <Grid columns={4} className="ml-2">
                <Grid.Column width={3} >
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {localStorage.getItem('customerNumber') == 1166 ? "Booking No" : t("order_number") || "Order No"}

                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {order.order_reference_no}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {orderDetail.movement_type == "Import" || orderDetail.movement_type == "Importar" ? t("estimated_on") : t("required_on")}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >

                    {localStorage.getItem('customerNumber') == 1122 ? moment.parseZone(orderDetail.required_on).format('DD-MM-YYYY') : moment.parseZone(orderDetail.required_on).format('DD-MM-YYYY HH:mm')}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("route") || "Route"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {routeDetails.source} - {routeDetails.destination}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("movement_type") || "Movement Type"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName  movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {orderDetail.movement_type}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("proposed_vehicle_type") || "Proposed Vehicle Type"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {order.vehicle_type}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("from_location") || "Origin"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {routeDetails.source}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("to_location") || "Destination"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {routeDetails.destination}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("weight") || "Net weight"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName movement_type"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {order.gross_weight}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("final_rate") || "Final Rate"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {order.freight_rate ? order.freight_rate : "NA"}
                  </Header>
                </Grid.Column>
                {localStorage.getItem("customerNumber") == 1123 && <> <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {"Dispatch Location"}
                  </Header>
                </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {this.handleDispatchLocation(order.dispatch_location_id)}
                      {this.state.mappedDispatchLocation}
                    </Header>
                  </Grid.Column> </>}
              </Grid>
            </div>
            {shipmentDetail && shipmentDetail.length > 0 ?
              (
                <>
                  <div className="pad w3-white small">
                    <Header as='h5' dividing className="m-2 ml-4 mb-4 p-bold-600 small">
                      {t("document_upload") || "Documents"}
                      {show_current_bl ? (
                        <Dropdown
                          defaultValue={
                            show_current_bl
                          }
                          options={blList}
                          className="ml-5"
                          name="current_bl_index"
                          onChange={(name, data) => {
                            this.setCurrentBLToShow(name, data);
                          }}
                        />
                      )
                        : (null)}

                    </Header>

                    <Grid columns={4} className="ml-2">
                      {this.getDocType("mother_invoice") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.mother_invoice") || "Mother Invoice"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("mother_invoice")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("mother_invoice")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {this.getDocType("original_bl") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.original_bl") || "Original BL"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("original_bl")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />

                            </Button>
                            <label> {this.getfileName("original_bl")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {this.getDocType("proof_of_id") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.proof_of_dI") || "Proof of DI"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("proof_of_id")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("proof_of_id")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {this.getDocType("inv_invoice") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.INV_invoice") || "INV - Invoice"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("inv_invoice")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("inv_invoice")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {this.getDocType("exoneration") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.exoneration") || "Exoneration"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("exoneration")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("exoneration")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}


                      {this.getDocType("packing_list") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.packing_list") || "Packing List"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("packing_list")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("packing_list")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}


                      {this.getDocType("failure_extract") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.failure_extract") || "Failure Extract"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("failure_extract")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("failure_extract")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {coa_docs.length > 0 ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.coa") || "COA"}
                            </Header>
                          </Grid.Column>

                          <Grid.Column width={4}>
                            {coa_docs.map((object, i) => (
                              <>
                                <Button size="mini"
                                  basic type="button"
                                  onClick={() => this.downloadFile(object["id"])}
                                  color="blue"
                                  key={i}
                                  icon>
                                  <Icon name="download" />
                                </Button>
                                <label> {object["name"]} </label>
                                <br />
                              </>
                            ))}
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {this.getDocType("bd_shipment_database") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.shipment_database") || "BD - Shipment Database"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("bd_shipment_database")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("bd_shipment_database")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}


                      {this.getDocType("excel_request_for_collection") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.excel_request_for_collection") || "Excel (Request for Collection)"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("excel_request_for_collection")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("excel_request_for_collection")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}


                      {this.getDocType("di") ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.di") || "DI"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>

                            <Button size="mini"
                              basic type="button"
                              onClick={() => this.downloadFile(
                                this.getDocId("di")
                              )}
                              color="primary"
                              icon>
                              <Icon name="download" />
                            </Button>
                            <label> {this.getfileName("di")}</label>
                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                      {fispq_and_fe_docs.length > 0 ? (
                        <>
                          <Grid.Column width={3} >
                            <Header
                              className="p-bold-600 labelName"
                              size="tiny"
                              as="label"
                              color="grey"
                            >
                              {t("document.FISPQ_and_FE") || "FISPQ and FE"}
                            </Header>
                          </Grid.Column>
                          <Grid.Column width={4}>
                            {fispq_and_fe_docs.map((object, i) => (
                              <>
                                <Button size="mini"
                                  basic type="button"
                                  onClick={() => this.downloadFile(object["id"])}
                                  color="blue"
                                  key={i}
                                  icon>
                                  <Icon name="download" />
                                </Button>
                                <label> {object["name"]} </label>
                                <br />
                              </>
                            ))}

                          </Grid.Column>
                        </>
                      ) : (
                        null
                      )}

                    </Grid>
                  </div>
                </>
              ) : (
                null
              )}
            {/* {deliveries ? (deliveries.map((deliveries, i) => (
              <DeliveryDetailsComponent deliveries={deliveries} t={t} orderDetail={orderDetail} />
            ))) : ''} */}

            {deliveries ?
              <div className="pad w3-white small">
                <DeliveryDetailComponentRebuilt
                  orderTruckLoadType={orderTruckLoadType}
                  deliveries={deliveries}
                  t={t}
                  orderDetail={orderDetail}
                  getOrderDetails={this.getOrderDetails}
                  serviceType={serviceType}
                />
              </div>
              :
              ""
            }

            {broadcastDetails ? <div className="pad w3-white small">
              <Header as='h5' dividing className="m-2 mb-4 p-bold-600 small">

                {t("broadcast_details") || "Broadcast Details"}
              </Header>
              <Grid columns={4} className="ml-2">
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("broadcast_start") || "Broadcast Start Date & Time"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {moment.parseZone(broadcastDetails.broadcast_start_datetime).format('DD-MM-YYYY HH:mm')}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("broadcast_end") || "Broadcast End Date & Time"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {moment.parseZone(broadcastDetails.broadcast_end_datetime).format('DD-MM-YYYY HH:mm')}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("offered_rate") || "Offered Rate"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {broadcastDetails.base_rate}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("uom") || "Uom"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {broadcastDetails.uom}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("return_load") || "Return Load"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-600 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >

                    {broadcastDetails.return_load == true ? 'Available' : 'Not Available'}
                  </Header>
                </Grid.Column>

                {localStorage.getItem('customerNumber') == "2" ?
                  <>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("loading_done_by.title") || "Loading Done By"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.loading_done_by}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("loading_charges.title") || "Loading Charges"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.loading_charges}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("unloading_done_by.title") || "Unloading Done By"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.unloading_done_by}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("unloading_charges.title") || "Unloading Charges"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.unloading_charges}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("insured_by.title") || "Insured By"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.insured_by}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("advance_payment.title") || "Advance Payment"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.advance_payment}%
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("credit_period_for_settlement.title") || "Credit Period For Settlement"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-600 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {broadcastDetails.credit_period_for_settlement}
                      </Header>
                    </Grid.Column>
                  </>
                  : null}
              </Grid>

            </div> : null}
            {order ? (order.allotment_status.allotment_code != "ALLOC" && order.allotment_status.allotment_code != "REJECT" /* && orderTruckLoadType !== 2 */ ?
              <FormikAllotedVehicles acceptance={deliveries ? (deliveries.map((deliveries, i) => (
                deliveries.consignor && deliveries.consignee ? false : true
              ))) : true} deliveries={deliveries} order_status={order.allotment_status.allotment_code} movement_type={orderDetail.movement_type} order={order} orderTruckLoadType={orderTruckLoadType} />
              : "") : ""}

            {(orderTruckLoadType === 2) && order.allotment_status.allotment_code != "ALLOC" && order.allotment_status.allotment_code != "REJECT" && false ?
              <Segment color="blue" className="m-3">
                <Header size="tiny">
                  Allocation
                </Header>

                <center>
                  <Button
                    className="m-2"
                    onClick={handleAllocationForPTL}
                    size="mini"
                    // disabled={disabled_status}
                    primary>
                    Allocate Order
                  </Button>
                </center>

              </Segment>
              :
              ""
            }
          </>
        ) : (
          <LoadingPlaceholder />
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(translate("order_details")(AllotedOrderDetails));
